import { render, staticRenderFns } from "./newBotPostLayout.vue?vue&type=template&id=0315baaf&scoped=true&"
import script from "./newBotPostLayout.vue?vue&type=script&lang=js&"
export * from "./newBotPostLayout.vue?vue&type=script&lang=js&"
import style0 from "./newBotPostLayout.vue?vue&type=style&index=0&id=0315baaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315baaf",
  null
  
)

export default component.exports